import type { Nullable } from "../types";
import { guardNumber } from "./guard-number";

/**
 * Converts a number to a string with 2 decimal places and appends "h" at the end.
 * @param input
 * @returns
 */
export function getHoursString(input: Nullable<number>): string {
	/** Cast */
	const number = new Intl.NumberFormat("de-DE", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(guardNumber(input));

	/** Return */
	return `${number} h`;
}
